import ScriptHelper from "./ScriptHelper";

export default class CKEditorHelper {
    static load() {
        if (!CKEditorHelper.is_loading) {
            CKEditorHelper.is_loading = true;

            ScriptHelper.load_script(window.CONFIG.urls.admin + "ckeditor/ckeditor.js").then(() => {
                CKEDITOR.disableAutoInline = true;
                load_resolve();
            });
        }

        return CKEditorHelper.load_promise;
    }

    static update_all() {
        if (!window.CKEDITOR) return;

        try {
            Object.values(window.CKEDITOR.instances).forEach((editor) => editor.updateElement());
        } catch (e) {
            console.warn("Couldn't update CKEDITORs", e);
        }
    }
}

let load_resolve;
CKEditorHelper.load_promise = new Promise((resolve) => load_resolve = resolve);
